export const ViewsStyles = {
  // Main button styles
  viewsButton: {
    textTransform: "none",
    backgroundColor: "#1976d2",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },

  // Popover styles
  popover: {
    marginTop: 1,
  },
} as const;
